import { render, staticRenderFns } from "./LostFound.vue?vue&type=template&id=2dc85b40&scoped=true"
import script from "./LostFound.vue?vue&type=script&lang=js"
export * from "./LostFound.vue?vue&type=script&lang=js"
import style0 from "./LostFound.vue?vue&type=style&index=0&id=2dc85b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc85b40",
  null
  
)

export default component.exports